// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1DyNf","left":"StickyBox_left__PZHZ2","right":"StickyBox_right__F2MNq"};